<template>
  <v-app>
    <AppBar routeTo="login" btnName="Log in" />
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="6" md="5">
          <v-card width="600" class="pa-4 custom-card" flat>
            <!-- Your card content goes here -->
            <v-form
              @submit.prevent="forgotPassword"
              v-model="isFormValid"
              ref="form"
            >
              <div
                class="ml-4 mb-2 text-h6 text-md-h5 text-lg-h4 font-weight-bold font-theme"
              >
                Forgot your password?
              </div>
              <div class="ml-4 grey2--text mb-2">
                Enter your account email address
              </div>
              <v-card-text class="pb-0">
                <div class="mb-1 subtitle-2 grey3--text">Email</div>
                <v-text-field
                  placeholder="example@gmail.com"
                  v-model="email"
                  :rules="emailRules"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                ></v-text-field>
                <v-btn
                  class="mt-2 primary white--text lowercase-text"
                  block
                  plain
                  :loading="$store.state.loading.forgotBtn.load"
                  :disabled="$store.state.loading.forgotBtn.disabled"
                  type="submit"
                >
                  Submit
                </v-btn>
                <v-card-text
                  class="display-6 text-center pr-0 row-pointer mt-2"
                >
                  <div class="grey2--text">
                    Return to
                    <span
                      @click="routeToHandler"
                      class="hover--text row-pointer"
                      >Log in</span
                    >
                  </div>
                </v-card-text>
              </v-card-text>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import AppBar from "@/components/shared/AppBar";
export default {
  components: { AppBar },
  data() {
    return {
      email: null,
      isFormValid: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
    };
  },
  methods: {
    async forgotPassword() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("forgotPassword", {
          email: this.email,
        });
        if (this.$store.state.loading.forgotBtn.proceed) {
          this.$router.push({ name: "forgot-succcess" });
        }
      }
    },
    routeToHandler() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
